/* src/app/modules/contact/contact/contact-dialog-t.component.css */
.ctd-header-text {
  min-width: 0;
  padding-right: 32px;
}
.ctd-header-text .cf-dlg-title,
.ctd-header-text .cf-dlg-subtitle {
  overflow-wrap: anywhere;
}
.ctd-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 14px;
}
.ctd-tabs {
  display: inline-flex;
  gap: 4px;
  padding: 4px;
  background: #f4f6f8;
  border-radius: 10px;
}
.ctd-tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: none;
  background: transparent;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #6b7280;
  cursor: pointer;
  white-space: nowrap;
}
.ctd-tab mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.ctd-tab--active {
  background: #fff;
  color: #1a1d23;
  box-shadow: 0 1px 3px rgba(0, 0, 0, .08);
}
.ctd-tab__count {
  min-width: 20px;
  padding: 0 6px;
  border-radius: 10px;
  background: #e5e7eb;
  color: #4b5563;
  font-size: 11px;
  line-height: 18px;
  text-align: center;
}
.ctd-tab--active .ctd-tab__count {
  background: var(--cf-brand, #e3fd64);
  color: rgba(0, 0, 0, .85);
}
.ctd-search {
  flex: 1 1 220px;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 6px;
  height: 34px;
  padding: 0 8px 0 10px;
  border: 1px solid var(--cf-border, #e5e7eb);
  border-radius: 8px;
  background: #fff;
}
.ctd-search:focus-within {
  border-color: #c5d94a;
}
.ctd-search > mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #9ca3af;
  flex-shrink: 0;
}
.ctd-search input {
  flex: 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  font-size: 13px;
  color: #1a1d23;
}
.ctd-search__clear {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: #9ca3af;
  cursor: pointer;
}
.ctd-search__clear:hover {
  background: #f3f4f6;
  color: #374151;
}
.ctd-search__clear mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.ctd-totals {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 14px;
}
.ctd-total {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  padding: 8px 14px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
}
.ctd-total--highlight {
  border-color: #c5d94a;
  background: #fbfee8;
}
.ctd-total__label {
  font-size: 12px;
  color: #6b7280;
  white-space: nowrap;
}
.ctd-total__value {
  font-size: 15px;
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ctd-total__value--paid {
  color: var(--cf-success, #16a34a);
}
.ctd-total__value--pending {
  color: var(--cf-warning, #d97706);
}
.ctd-total__value--previous {
  color: var(--cf-error, #dc2626);
}
.ctd-table-wrap {
  overflow-x: auto;
  border: 1px solid #eef1f4;
  border-radius: 8px;
}
.ctd-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.ctd-table th {
  background: #f4f6f8;
  color: #6b7280;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .04em;
  text-align: left;
  padding: 8px 12px;
  white-space: nowrap;
}
.ctd-table td {
  padding: 6px 12px;
  color: #2f3540;
  border-top: 1px solid #eef1f4;
  vertical-align: middle;
}
.ctd-table tbody tr:hover td {
  background: #fafbfc;
}
.ctd-th--sortable {
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
}
.ctd-th--sortable:hover {
  color: #1a1d23;
}
.ctd-sort {
  font-size: 14px;
  width: 14px;
  height: 14px;
  vertical-align: middle;
}
.ctd-num {
  text-align: right !important;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.ctd-nowrap {
  white-space: nowrap;
}
.ctd-strong {
  font-weight: 600;
  color: #1a1d23 !important;
  white-space: nowrap;
}
.ctd-name {
  min-width: 160px;
  max-width: 280px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ctd-paid-date {
  margin-left: 6px;
  font-size: 12px;
  color: #6b7280;
}
.ctd-actions-col {
  text-align: right !important;
  width: 1%;
  white-space: nowrap;
}
.ctd-actions {
  display: inline-flex;
  gap: 2px;
}
.ctd-action.mat-mdc-icon-button {
  width: 32px;
  height: 32px;
  padding: 4px;
  color: #6b7280;
}
.ctd-action.mat-mdc-icon-button:hover {
  color: #1a1d23;
}
.ctd-action mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.ctd-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 36px 16px;
  text-align: center;
  border: 1px dashed #e5e7eb;
  border-radius: 10px;
  background: #fafbfc;
}
.ctd-empty mat-icon {
  font-size: 36px;
  width: 36px;
  height: 36px;
  color: #d1d5db;
}
.ctd-empty--error mat-icon {
  color: var(--cf-error, #dc2626);
}
.ctd-empty__title {
  font-size: 14px;
  font-weight: 600;
  color: #1a1d23;
}
.ctd-empty__text {
  font-size: 13px;
  color: #6b7280;
}
@media (max-width: 767px) {
  .ctd-totals {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .ctd-tabs {
    width: 100%;
  }
  .ctd-tab {
    flex: 1;
    justify-content: center;
  }
  .ctd-search {
    flex-basis: 100%;
  }
  .ctd-excel {
    width: 100%;
  }
}
@media (max-width: 400px) {
  .ctd-totals {
    grid-template-columns: 1fr;
  }
}
/*# sourceMappingURL=contact-dialog-t.component.css.map */
